.Icon {
  &_inline {
    vertical-align: text-bottom;
    margin-right: 0.25em;
  }
}
